import { Toggle, Typography } from "@drone-js/core";
import { HStack, VStack } from "apps/commons/components/Stack";
import type { FunctionComponent, PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
    id: string;
    title: string;
    description?: string;
    selected: boolean;
    onClick: (checked: boolean) => void;
    toggleDataElementName?: string;
}

export const DiscountLayout: FunctionComponent<Props> = ({
    id,
    title,
    description,
    selected,
    onClick,
    toggleDataElementName,
    children,
}) => {
    return (
        <VStack backgroundColor="base.background" gap="16" borderRadius="8" p="16">
            <HStack justifyContent="space-between" alignItems="center">
                <VStack gap="8">
                    <Typography variant="body-s-strong">{title}</Typography>
                    {description && (
                        <Typography variant="body-s" textColor="base.subtle">
                            {description}
                        </Typography>
                    )}
                </VStack>
                <Toggle
                    id={id}
                    selection={selected ? "selected" : "unselected"}
                    onChange={onClick}
                    data-element-name={toggleDataElementName}
                />
            </HStack>
            {children}
        </VStack>
    );
};
